import axios from 'axios'
import { envConfig } from '../../../env';

const gmUrl = envConfig.formalServer + "/mars"             //本地链接
// const gmUrl = 'https://server.cottongame.com/mars'    //线上链接


export const getNormalUser = params => axios.post(gmUrl + '/getMarsUserToGM', params)                   // 获取所有用户


//--- MarsNotice.vue
export const getMarsNotice = params => axios.post(gmUrl + '/getMarsNotice', params)                     // 获取公告信息
export const updateNoticeShowState = params => axios.post(gmUrl + '/modifyNoticeShowStateToGM', params) // 修改公告显示状态

//--- MarsEmail.vue
export const getEmail = params => axios.post(gmUrl + '/getEmailToGM', params)                    // 获取邮件信息
export const updateEmailStatus = params => axios.post(gmUrl + '/updateEmailStatusToGM', params)  // 修改邮件显示状态

//--- MarsPriceRecord.vue
export const getPriceRecord = params => axios.post(gmUrl + '/getPriceRecordToGM', params)        // 获取银河车票记录信息

//--- MarsAddPriceRecord.vue
export const getPriceKeyByUserId = (params) => axios.post(gmUrl + '/getPriceKeyByUserId', params)     // 获得银河列车票key
export const updateUserPrice = (params, headers) => axios.post(gmUrl + '/updateUserPrice', params, {  // 添加银河车票
    headers: {
        'sign': headers.sign
    }
})

//--- MarsManager.vue
export const bannedUserTOGM = (params) => axios.post(gmUrl + '/bannedUserTOGM', params)          // 封禁玩家

//--- Notice.vue
export const postMarsNotice = params => axios.post(gmUrl + '/addMarsNoticeToGM', params)         // 新增公告

//--- Email.vue
export const postEmail = params => axios.post(gmUrl + '/addEmailToGM', params)                   // 新增邮件
export const getEmailById = params => axios.post(gmUrl + '/getEmailByIdToGM', params)            // 获取邮件 根据Id
